import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        field: '='
    },
    template: `
        <div class="heading01 type01">
            <h1>{{ vm.field.activeI18n.value }}</h1>
            <ul class="actions01">
                <li>
                    <a ng-click="vm.manageTranslations()" class="btn main small">{{ 'general.Manage translations' | translate }}</a>
                </li>
                <li>
                    <a ng-click="vm.delete()" class="btn negative">{{ 'general.Delete' | translate }}</a>
                </li>
                <li>
                    <a ui-sref="authorized.courses.fields.list()" class="btn discrete" >{{ 'general.Back to list' | translate }}</a>
                </li>
            </ul>
        </div>
        <courses-fields-form form="vm.form" field="vm.field">
    `
})
export default class {
    constructor (FormFactory, ModalService, $translate, ClassifierResource, $state) {
        this.form = FormFactory.create(this.field, model => model.$update({ id: model.id, expand: 'classifierI18ns,activeI18n' }));
        this.ModalService = ModalService;
        this.$translate = $translate;
        this.ClassifierResource = ClassifierResource;
        this.$state = $state;
    }

    manageTranslations () {
        const { field } = this;
        return this.ModalService.open({
            template: `
                <modals-classifier-translation
                    value-label="vm.valueLabel"
                    classifier="vm.field"
                    cancel="vm.$uibModalInstance.dismiss()" />
                `,
            size: 'xlarge',
            controller ($translate, $uibModalInstance) {
                this.valueLabel = $translate.instant('course.Field');
                this.$uibModalInstance = $uibModalInstance;
                this.field = field;
            }
        });
    }

    delete () {
        const { field } = this;
        const confirmMessage = this.$translate.instant('classifier.Are you sure you wish to delete the training field?');
        this.ModalService.confirm(confirmMessage, 'medium').then(() => {
            this.ClassifierResource.delete({ id: field.id }).$promise.then(() => {
                this.$state.go('authorized.courses.fields.list');
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/fields/detail/index.js